import { privateAxios } from 'services/api/privateAxios';

export const getDriverStatus = () =>
  privateAxios({
    method: 'post',
    url: '/driver/getstatus',
  });
